style= require('./results.styl')
.wrapper
  .match
    sporty-sc-validator(match=match)
    if sport === 'tennis'
      h3.danger In tennis: Use the "pause" button or games won't be counted correctly
    if sport === 'basket'
      h3.danger In basket: Give players at least 1 minute playtime for points to count
    a(href="/matches/" + match._id + "/conf")
      ft-button(warning) Detailed confirmation screen
    sporty-status(
      match=match,
      edit,
      view-dashboard,
      (toggle-bop)= changeFilterBOP(e)
      )
    sporty-events(match=match, validity, filterBop=filterBop)
  .controls
    .enter-stats
      .control-panel
        .scrapers
          each source in matchSources
            if canScrapeLineups(source)
              if match.season.autoconfirm
                ft-toggle(
                  checked=match.autoconfirm,
                  (toggle)=this.toggleAutoconfirm(e)
                ) AC
              - const uid = this.uid(match)
              ft-button.scrape(
                warning,
                (click)=this.scrapeLineups(source)
              )
                if uid
                  = `Scrape UID ${uid} - ${source.source}`
                else
                  = `Scrape ${source.source}`


            if canClearEvents(source)
              ft-button.scrape(
                warning,
                (click)=this.scrapeLineups(source, { clearEvents: true })
              ) Clear Events and rescrape

            if this.match.sport === 'csgo' && source.source !== 'custom' && source.uid
              ft-button.scrape(
                danger,
                (click)=this.clearEvents(source, 2)
              ) Clear Events and rescrape

            if this.match.sport === 'csgo' && source.source !== 'custom' && source.uid
              ft-button.scrape(
                danger,
                (click)=this.clearEvents(source, 2, 'historical')
              ) Historical Scrape

            if canScrapeStats(source)
              ft-button.scrape(warning, (click)=this.scrapeLineups(source, {onlyStats: true}))
                | Stats only (#{source.source})
        .editor
          sporty-match-times(
            match=match
          )
          ft-button(data-clear)
            | Clear
            span.shortcut (space)
          ft-button(href=`/matches/${match._id}/feeds`)
            | Download Feed
          if canStopCompute && !match.stopCompute
            ft-button(danger, (click)=this.toggleCompute(false))
              | Stop Computation
          if canStopCompute && match.stopCompute
            ft-button(warning, (click)=this.toggleCompute(true))
              | Reopen Computation
          a(href="/matches/" + match._id + "/lineups")
            ft-button(warning) Match Setup
          ft-button(success,
            (click)=this.sendFeeds(),
            disabled=match.$isSubmitting
          ) Send events
          if sport === 'tennis'
            ft-button(success,
              (click)=this.compute(),
              disabled=match.$isSubmitting
            ) Recompute
      sporty-event-selector.selector(match=match)
      .teams-wrapper
        each team, i in match.teams
          .lineups(class=['home', 'away'][i])
            .team(
              (click)=this.select(team),
              class={active: this.team === team})
              img.logo(src=team.iconUrl)
              .name= team.name
            each block in blocks
              if block.header
                .subs= block.header
              sporty-lineups.block(
                match=match,
                team=team
              )&attributes(block)
            if this.match.sport === 'csgo'
              ft-button.scrape(
                danger,
                (click)=this.addExtraPlayer()
              ) Add Extra Player
              if extraPlayerMenu && this.match.sport === 'csgo'
                input(
                  type="number",
                  value=(match.overrides && match.overrides.extraPlayer) || 0,
                  (input)=this.makeExtraPlayer(e.target.value, i)
                )
                ft-button(
                  (click)=this.sendExtraPlayer()
                )='Add extra player'

      if isQuickSets
        sporty-quick-sets.block(
          match=match
        )
      else
        sporty-event.block(
          match=match
        )
        sporty-event-submitter.block(
          match=match
        )
    .edit-stats
      if match.season.sportsbookOnly
        label='Home score'
        input(
          type='number',
          [value]=match.scores && match.scores[0] || 0,
          (input)=this.setScore(e.target.value, 0))
        label='Away score'
        input(
          type='number',
          [value]=match.scores && match.scores[1] || 0,
          (input)=this.setScore(e.target.value, 1))
        .match-info
          label='Roundscores    '
          .match-info
            label='P1'
            input(
              type="number",
              value=match.roundScores && match.roundScores[0] && (match.roundScores[0][0] || 0) ,
              (input)=this.setRoundScore(e.target.value, 0, 0),
            )
            input(
              type="number",
              value=match.roundScores && match.roundScores[0] && (match.roundScores[0][1] || 0) ,
              (input)=this.setRoundScore(e.target.value, 0, 1),
            )
          .match-info
            label='P2'
            input(
              type="number",
              value=match.roundScores && match.roundScores[1] && (match.roundScores[1][0] || 0) ,
              (input)=this.setRoundScore(e.target.value, 1, 0),
            )
            input(
              type="number",
              value=match.roundScores && match.roundScores[1] && (match.roundScores[1][1] || 0) ,
              (input)=this.setRoundScore(e.target.value, 1, 1),
            )
        .custom-button
          ft-button(
              primary, (click)=this.saveScoreChanges()
            )='Save score changes'
          ft-button(
              primary, (click)=this.clearOverride()
            )='Remove Override'
      if hasEditableMatchStats
        ft-accordion.stats(open=this.open)
          header(slot='header')
            .match-info
              .label="Editable match stats"
              each stat in editableMatchStats
                .label= stat
                  .input
                    input(
                      type="number",
                      value=match[stat],
                      disabled=this.isStatEnabled(stat),
                      (input)=this.setMatchStat(e.target.value, stat),
                    )
                    ft-button(success,
                      (click)=this.changeMatchStatStatus(stat),
                    )
                      if this.enabledStats[stat]
                        .action Disable
                      else
                        .action Enable
            if match.isEsports
              each block, index in statBlocks
                  if block.header
                    em= block.header
                  .map-info
                    input(
                      type="number",
                      value=match.roundScores && match.roundScores[index] && (match.roundScores[index][0] || 0) ,
                      (input)=this.setRoundScore(e.target.value, index, 0),
                    )
                    input(
                      type="number",
                      value=match.roundScores && match.roundScores[index] && (match.roundScores[index][1] || 0) ,
                      (input)=this.setRoundScore(e.target.value, index, 1),
                    )
              ft-button(
                primary, (click)=this.editMatchStats()
              )='Save changes'
              .fix-maps
                if fixMenu
                  each n in [1,2,3,4,5]
                    em='New Map Number'
                    input(
                      type="number",
                      value=match.overrides && match.overrides.mapOverride && match.overrides.mapOverride.adjustedMapNumber,
                      (input)=this.setNewMapNumber(n, e.target.value)
                      )
                    select((change)=this.setNewMapName(n, e.target.value))
                      option(selected disabled) 'Select Map'
                      for map in mapNames
                        option(
                          value=map,
                          selected=(this.newMapName === map)
                        )= map
                  ft-button(
                    (click)=this.fixMap()
                  )='Fix Maps'
                  ft-button(
                    (click)=this.clearOverride()
                  )='Remove Override'
                  .em='Batch'
                    input(
                      type="number",
                      (input)=this.setClearBatch(e.target.value)
                    )
                  .em='Round'
                    input(
                      type="number",
                      (input)=this.setClearRound(e.target.value)
                    )
                  ft-button.scrape(
                    danger,
                    (click)=this.invalidateSpecificRound()
                  ) Invalidate Specific Round
                else
                  ft-button(
                    primary,
                    (click)=this.toggleFixMenu()
                  )=this.fixMenu ? 'Close Fix Menu' : 'Open Fix Menu'

    .edit-stats
      each team in match.teams
        ft-accordion.stats(open=this.open)
          header(slot='header')
            .team-info
              img.team-logo(src=team.iconUrl)
              span.name= team.name
            .edit-team
              if team.editStats && team.showStats
                ft-button.save(success, (click)=this.saveStats(team))='Save'
              ft-button(
                primary,
                disabled=!(team.showStats || this.editHockey),
                (click)=this.editStats(team)
              )=team.editStats && team.showStats ? 'Cancel' : 'Edit stats'
              if !(team.editStats && team.showStats)
                ft-button(
                  primary,
                  disabled=!(team.showStats || this.editHockey),
                  (click)=this.syncProjectedPoints(team)
                )= 'Sync PP'

              .arrow-col(
                disabled=this.match.sport === 'hockey',
                (click)=this.showStats(team))
                if team.showStats
                  ft-icon.arrow(name="ui--collapse")
                else
                  ft-icon.arrow(name="ui--expand")
        section
          if team.showStats || this.editHockey
            each block in statBlocks
              if block.header
                em= block.header
                em= ' --- '
                  ft-button(
                    (click)=this.toggleSums()
                  )=this.showSums ? 'Hide Sums' : 'Show Sums'
                if this.showSums
                  each stat in this.allStats(block.batch, team)
                    - let total = this.findTotalStat(stat, block.batch, team)
                    if total
                      em= '  ' + stat + ': ' + this.findTotalStat(stat, block.batch, team)
              if team.editStats && block.addNew
                select((change)=this.addTeamLineup(block, team, e.target.value))
                  option(selected disabled) <choose a new player to add>
                  each player in this.teamPlayers(team)
                    option(value=player._id)= player.name
              sporty-stats.block(
                match=match,
                team=team,
                edit-mode=block.isEditable && team.editStats
              )&attributes(block)
